export default "__VITE_ASSET__COOF1BiH__"